import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedService } from "./../../../shared/shared.service";
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PrasadOrderView } from './../../../prasad-order/prasad-order';
import { PujaPrasadMaster } from './../../../prasad-order/puja-prasad-master';
import { DevoteePrasadOrderVM } from './../../models/devotee-prasad-order-vm';
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AdminPrasadOrderVM } from '../../models/admin-prasad-order-vm';

@Component({
  selector: 'app-po-dispatch',
  templateUrl: './po-dispatch.component.html',
  styleUrls: ['./po-dispatch.component.css'],
  providers: [AdminPrasadOrderService, AdminMobileappService]
})
export class PoDispatchComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService,
    private adminMobileAppService: AdminMobileappService) { }

  dispatchForm: FormGroup;
  devoteeDetail: DevoteeDetail;
  prasadOrder: AdminPrasadOrderVM;
  pujaPrasadMaster: PujaPrasadMaster;
  devoteePrasadOrderVMList: DevoteePrasadOrderVM[] = [];
  adminPrasadOrderVMList: DevoteePrasadOrderVM[] = [];

  errorMessage: string = "";
  successMessage: string = "";


  ngOnInit() {
    this.createDispatchForm();
    this.loadPODispatchList();
  }

  loadPODetails(e, el) {

    if (e.keyCode != 13) {
      return;
    }

    console.log(el);

    this.errorMessage = "";
    let poNoWithText: string = this.dispatchForm.controls.PONo.value;
    let poExtention = poNoWithText.substring(0, 2);
    if (poExtention === "PO") {
      let poNo = poNoWithText.replace("PO", "");
      this.loadPrasadOrderDetails(poNo, el);
    }

  }

  loadPrasadOrderDetails(poNo: any, el: any) {
    this.sharedService.showSpinner();
    this.adminPrasadOrderService.getbyPONo(poNo).subscribe(
      data => {
        console.log(data);
        this.prasadOrder = data.PrasadOrderVidhis.PageData[0];
        this.showSuccessErrorMsg(el);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  showSuccessErrorMsg(el: any) {
    if (this.prasadOrder.PrasadOrderStatus != "Puja Performed" && this.prasadOrder.PrasadOrderStatus != "Prasad Dispatched") {
      this.errorMessage = "Puja is not performed for this prasad Order";
      //this.dispatchForm.controls.SpeedPostNo.disable();
      el.focus();
    }

    if (this.prasadOrder && this.prasadOrder.DispatchNo) {
      this.dispatchForm.controls.SpeedPostNo.setValue(this.prasadOrder.DispatchNo);
      this.errorMessage = "Prasad has been dispatched";
      //this.dispatchForm.controls.SpeedPostNo.disable();
      el.focus();
    } else {
      this.dispatchForm.controls.SpeedPostNo.enable();
      // this.dispatchForm.controls.SpeedPostNo.setValue(this.prasadOrder.Id);
      el.focus();
    }
  }

  speedPostNoEnter(e, el) {

    if (e.keyCode != 13) {
      return;
    }

    this.poDispached(el);
  }

  poDispached(el) {

    if (this.dispatchForm.invalid) {
      this.sharedService.validateAllFormFields(this.dispatchForm);
      console.log(this.dispatchForm.errors);
      return;
    }

    this.prasadOrder.DispatchNo = this.dispatchForm.controls.SpeedPostNo.value;
    this.prasadOrder.PrasadOrderStatus = "Prasad Dispatched";

      let updateEntity = {
        PrasadOrderId: this.prasadOrder.OrderId,
        PujaVidhiId: this.prasadOrder.PujaVidhiId,
        DispatchNumber: this.prasadOrder.DispatchNo
      };

      this.sharedService.showSpinner();
      this.adminPrasadOrderService.updateDispatchedOrders(updateEntity).subscribe(
        data => {
          this.dispatchForm.reset();
          this.successMessage = "order update successfully";
          this.devoteeDetail = null;
          this.prasadOrder = null;
          this.pujaPrasadMaster = null;
          el.focus();
          this.loadPODispatchList();
        },
        err => {
          this.errorMessage = err.body;
          this.sharedService.hideSpinner();
        },
        () => this.sharedService.hideSpinner()
      )

      return;
    

    
  }

  loadPODispatchList2() {

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.GetPODispatchList().subscribe(
      data => {
        this.devoteePrasadOrderVMList = data;
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  loadPODispatchList() {

    this.sharedService.showSpinner();

    var searchRequest = { HasDispatched: true, PageNo: 1, PageSize: 10 };

    this.adminPrasadOrderService.search(searchRequest).subscribe(
      data => {
        this.adminPrasadOrderVMList = data.PrasadOrderVidhis.PageData;        
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }



  createDispatchForm(): void {
    this.dispatchForm = this.formBuilder.group({
      PONo: [],//, [Validators.required, Validators.pattern("^PO\\d+")]],
      SpeedPostNo: []//, [Validators.required, Validators.pattern("^CM\\d+IN")]]
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/admin/components/po-dispatch/po-dispatch.component.ts